<div class="shared-file-page">
  <div *ngIf="state === 'loading'" class="shared-file-state">
    <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="4"></p-progressSpinner>
  </div>

  <div *ngIf="state === 'not_found'" class="shared-file-state">
    <i class="pi pi-ban"></i>
    <p>{{ 'sharedFile.notFound' | transloco }}</p>
  </div>

  <div *ngIf="state === 'expired'" class="shared-file-state">
    <i class="pi pi-clock"></i>
    <p>{{ 'sharedFile.expired' | transloco }}</p>
  </div>

  <div *ngIf="state === 'available' && info" class="shared-file-layout">
  <div class="shared-file-card">
    <div class="shared-file-icon">
      <i [class]="info.type === 'log' ? 'pi pi-chart-line' : 'pi pi-th-large'"></i>
    </div>
    <h1 class="shared-file-name">{{ info.fileName }}</h1>
    <span class="shared-file-type">
      {{ (info.type === 'log' ? 'arquivos.uploadTypeLog' : 'arquivos.uploadTypeMap') | transloco }}
    </span>

    <dl class="shared-file-meta">
      <div>
        <dt>{{ 'sharedFile.sharedBy' | transloco }}</dt>
        <dd>{{ info.ownerName }}</dd>
      </div>
      <div *ngIf="createdDateUtc">
        <dt>{{ 'sharedFile.createdAt' | transloco }}</dt>
        <dd>{{ createdDateUtc | date: 'dd/MM/yyyy HH:mm' }}</dd>
      </div>
      <div>
        <dt>{{ 'sharedFile.expiresIn' | transloco }}</dt>
        <dd class="shared-file-countdown">{{ remainingLabel }}</dd>
      </div>
    </dl>

    <div class="shared-file-actions">
      <p-button icon="pi pi-download" [label]="'sharedFile.download' | transloco"
                severity="danger" (onClick)="download()" />
      <p-button *ngIf="!saved" icon="pi pi-cloud-upload" [label]="'sharedFile.save' | transloco"
                severity="secondary" [loading]="saving" (onClick)="save()" />
      <p-button *ngIf="saved" icon="pi pi-folder-open" [label]="'sharedFile.openArchives' | transloco"
                severity="secondary" (onClick)="goArchives()" />
      <p-button *ngIf="!isLoggedIn" icon="pi pi-user-plus" [label]="'sharedFile.createAccount' | transloco"
                severity="secondary" [text]="true" (onClick)="goCreateAccount()" />
    </div>
    <p *ngIf="saved" class="shared-file-hint">{{ 'sharedFile.saveProcessing' | transloco }}</p>
  </div>

  <aside class="shared-file-ai">
    <div class="shared-file-ai-head">
      <i class="pi pi-sparkles"></i>
      <h2>{{ 'sharedFile.ai.title' | transloco }}</h2>
    </div>
    <p class="shared-file-ai-lead">{{ 'sharedFile.ai.lead' | transloco }}</p>
    <ul class="shared-file-ai-list">
      <li><i class="pi pi-comments"></i>{{ 'sharedFile.ai.ask' | transloco }}</li>
      <li><i class="pi pi-chart-bar"></i>{{ 'sharedFile.ai.charts' | transloco }}</li>
      <li><i class="pi pi-search"></i>{{ 'sharedFile.ai.insights' | transloco }}</li>
    </ul>
    <p-button *ngIf="saved" icon="pi pi-sparkles" [label]="'sharedFile.ai.open' | transloco"
              severity="danger" (onClick)="goAssistant()" />
    <p *ngIf="!saved" class="shared-file-ai-foot">
      {{ (isLoggedIn ? 'sharedFile.ai.saveFirst' : 'sharedFile.ai.accountFirst') | transloco }}
    </p>
  </aside>
  </div>
</div>
